export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  EMPLOYEE = 'ROLE_EMPLOYEE',
  DEVELOPER = 'ROLE_DEVELOPER',
  USER = 'ROLE_USER'
}
